import React from 'react';

import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import { Chip } from '@mui/material';

type Props = {
  /** 拡張子（言語） */
  extension: string;
  /** クリア状況（受講画面用）。省略時はクリア表示なし */
  cleared?: boolean;
  size?: 'small' | 'medium';
};

/**
 * 言語（拡張子）を表すチップ。
 * cleared を渡すとクリア済み（success）/未クリア（outlined）で表示分けする。
 */
const LanguageChip: React.FC<Props> = ({ extension, cleared, size = 'small' }) => {
  if (cleared === undefined) {
    return (
      <Chip
        size={size}
        label={extension}
        variant="outlined"
        sx={{ borderRadius: 1, fontWeight: 600 }}
      />
    );
  }
  return (
    <Chip
      size={size}
      icon={cleared ? <CheckCircleIcon /> : <RadioButtonUncheckedIcon />}
      label={extension}
      color={cleared ? 'success' : 'default'}
      variant={cleared ? 'filled' : 'outlined'}
      sx={{ borderRadius: 1, fontWeight: 600 }}
    />
  );
};

export default LanguageChip;
